window.addEventListener('load', ()=> {
  const banner_slider = new Swiper('.banner-slider', {
    // Optional parameters
    direction: 'horizontal',
    speed: 400,
    loop: true,
    autoplay: {
          delay: 5000
        },
  
    // If we need pagination
    pagination: {
      el: '.banner-slider__pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.banner-slider__button-next',
      prevEl: '.banner-slider__button-prev',
    }
  });
  
  // console.log('Banner Slider →');
  
  // console.log(banner_slider);
  
});

